import { create } from 'zustand';

/**
 * Mains levées dans les bulles de la carte (userId), tenues par ColyseusClient
 * depuis `handRaised` des instantanés joueurs. Le serveur la baisse quand on
 * change de bulle.
 */
interface HandsState {
  raised: ReadonlySet<string>;
  set: (userId: string, raised: boolean) => void;
  reset: (userIds: Iterable<string>) => void;
}

export const useHandsStore = create<HandsState>((set) => ({
  raised: new Set(),
  set: (userId, raised) => set((s) => {
    if (s.raised.has(userId) === raised) return s;
    const next = new Set(s.raised);
    if (raised) next.add(userId); else next.delete(userId);
    return { raised: next };
  }),
  reset: (userIds) => set({ raised: new Set(userIds) }),
}));
